"use strict";

var _classCallCheck = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ethABI = require('web3-eth-abi');
/** encode/decode parameters of contract function call, event log, according to ABI JSON */


var abi;

(function (abi) {
  /** for contract function */
  var Function =
  /*#__PURE__*/
  function () {
    /**
     * create a function object
     * @param definition abi definition of the function
     */
    function Function(definition) {
      _classCallCheck(this, Function);

      this.definition = definition;
    }
    /** compute function signature */


    _createClass(Function, [{
      key: "encode",

      /**
       * encode input parameters into call data
       * @param args arguments for the function
       */
      value: function encode() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return ethABI.encodeFunctionCall(this.definition, args);
      }
      /**
       * decode output data
       * @param outputData output data to decode
       */

    }, {
      key: "decode",
      value: function decode(outputData) {
        return ethABI.decodeParameters(this.definition.outputs || [], outputData);
      }
    }, {
      key: "signature",
      get: function get() {
        return ethABI.encodeFunctionSignature(this.definition);
      }
    }]);

    return Function;
  }();

  abi.Function = Function;
  /** for contract event */

  var Event =
  /*#__PURE__*/
  function () {
    /** for contract event */
    function Event(definition) {
      _classCallCheck(this, Event);

      this.definition = definition;
    }
    /** compute event signature */


    _createClass(Event, [{
      key: "encode",

      /**
       * encode an object of indexed keys into topics.
       * @param indexed an object contains indexed keys
       */
      value: function encode(indexed) {
        var topics = [];

        if (!this.definition.anonymous) {
          topics.push(this.signature);
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.definition.inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var input = _step.value;

            if (!input.indexed) {
              continue;
            }

            var value = indexed[input.name];

            if (value === undefined || value === null) {
              topics.push(null);
            } else {
              // TODO: special case for dynamic types
              topics.push(ethABI.encodeParameter(input.type, value));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return topics;
      }
      /**
       * decode event log
       * @param data data in event output
       * @param topics topics in event
       */

    }, {
      key: "decode",
      value: function decode(data, topics) {
        return ethABI.decodeLog(this.definition.inputs, data, this.definition.anonymous ? topics : topics.slice(1));
      }
    }, {
      key: "signature",
      get: function get() {
        return ethABI.encodeEventSignature(this.definition);
      }
    }]);

    return Event;
  }();

  abi.Event = Event;
})(abi = exports.abi || (exports.abi = {}));